import {AuthorizationFetcher, utils} from '@wallaby-ui/core';

import {LIBRARY_NAME} from 'src/js/common/constants';
import pdf from 'src/js/lib/pdf_viewer/pdfjs_loader';

const logger = utils.LogUtils.getLogger('FileFetcher', LIBRARY_NAME);

/** @deprecated */
const FileFetcher = {
  get(requestUrl, docId) {
    if (!requestUrl || !docId) {
      logger.error(
        `Missing request endpoint, requestUrl: ${requestUrl}, docId: ${docId}`
      );
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(docId)}?projection=detail`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getPdf(requestUrl, docId, pdfMethod) {
    return this.getPdfFile(requestUrl, docId, pdfMethod).then((response) => {
      const result = response && response.result ? response.result : response;
      // handle empty response
      let pdfDocumentPromise;
      if (result) {
        pdfDocumentPromise = result.then((data) => {
          let dataResultPromise;
          if (data && data.byteLength > 0) {
            dataResultPromise = pdf.getDocument({data}).promise;
          } else {
            dataResultPromise = new Promise((resolve) => {
              // resolve empty object
              resolve({});
            });
          }
          return dataResultPromise;
        });
      } else {
        pdfDocumentPromise = new Promise((resolve) => {
          // resolve empty object
          resolve({});
        });
      }
      return pdfDocumentPromise
        .then((pdfDocument) => pdfDocument)
        .catch((error) => {
          if (error.name === 'MissingPDFException') {
            logger.warn(error.message);
          } else {
            utils.FetcherUtils.errorHandler(error);
          }
        });
    });
  },

  getPdfFile(requestUrl, docId, pdfMethod) {
    if (!requestUrl || !docId || !pdfMethod) {
      logger.error(
        `Missing request endpoint, requestUrl: ${requestUrl}, docId: ${docId}, requestMethod: ${pdfMethod}`
      );
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(docId)}/${pdfMethod}`,
      {method: 'get'},
      {'Content-Type': 'application/octet-stream'}
    )
      .then(utils.FetcherUtils.processOctetStreamResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getText(requestUrl, docId, textMethod) {
    if (!requestUrl || !docId || !textMethod) {
      logger.error(
        `Missing request endpoint, requestUrl: ${requestUrl}, docId: ${docId}, requestMethod: ${textMethod}`
      );
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(docId)}/${textMethod}`,
      {method: 'get'},
      {'Content-Type': 'application/atom+xml;charset=UTF-8'}
    )
      .then(utils.FetcherUtils.processTextResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getTextChunks(requestUrl, docId, textChunksMethod) {
    if (!requestUrl || !docId || !textChunksMethod) {
      logger.error(
        `Missing request endpoint, requestUrl: ${requestUrl}, docId: ${docId}, requestMethod: ${textChunksMethod}`
      );
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(docId)}/${textChunksMethod}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getAnnotations(requestUrl, docId, annotationsMethod) {
    if (!requestUrl || !docId || !annotationsMethod) {
      logger.error(
        `Missing request endpoint, requestUrl: ${requestUrl}, docId: ${docId}, requestMethod: ${annotationsMethod}`
      );
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(docId)}/${annotationsMethod}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  downloadFile(requestUrl) {
    if (!requestUrl) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}`);
    }
    return AuthorizationFetcher.interceptedFetch(
      requestUrl,
      {method: 'get'},
      {'Content-Type': 'application/octet-stream'}
    )
      .then((response) =>
        utils.FetcherUtils.processOctetStreamResponse(response, true, true, '')
      )
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      })
      .then(utils.FetcherUtils.saveBlobResponse);
  },

  /* eslint-disable no-else-return */
  getFile(requestUrl, docId, attachedFilesMethod, fileName) {
    if (!requestUrl || !docId || !attachedFilesMethod) {
      logger.error(
        `Missing request endpoint, requestUrl: ${requestUrl}, docId: ${docId}, requestMethod: ${attachedFilesMethod}`
      );
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(
        docId
      )}/${attachedFilesMethod}?file=${encodeURIComponent(fileName)}`,
      {method: 'get'},
      {'Content-Type': 'application/octet-stream'}
    )
      .then((response) =>
        utils.FetcherUtils.processOctetStreamResponse(
          response,
          true,
          true,
          fileName
        )
      )
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      })
      .then(utils.FetcherUtils.getBase64Response);
  },
  /* eslint-enable no-else-return */
};

export default FileFetcher;
